import { Count } from '../../../../shared/components';
import { useResources } from '../../resources.context';

export const FavouritesCount = () => {
  const {
    favourites: { isLoading, noCount, count },
  } = useResources();

  return (
    <Count
      title="Favourites"
      isLoading={isLoading}
      noCount={noCount}
      count={count}
    />
  );
};
